import React from 'react';
import {ReactComponent as ArrayIcon} from '../../../../../../../assets/main/groups/main-table/array.svg';
import {ReactComponent as CorrectIcon} from '../../../../../../../assets/main/test/response/text-questions/correct.svg';
import {NavLink, useParams} from "react-router-dom";
import {StudentTest} from "features/model/types/test/studentTestById";


interface StudentsTestItemProps {
    user: StudentTest;
}

export const StudentsTestItem = ({user}: StudentsTestItemProps) => {

    const {testId} = useParams()


    return (
        <div className="row" key={user.id}>
            <div className="col lesson-col full-width-mobile">
                <span className="col-title">Студент</span>
                <div className="student-data-box">
                    <div className="avatar">
                        <img src={user.avatar} alt={user.fullName}/>
                        <span className={`status-label ${user.onlineStatus}`}/>
                    </div>
                    <div className="student-data">
                        <p className="name">
                            {user.status === 'done' ? (
                                <NavLink to={`/test/${testId}/view-answer/${user.id}`}>{user.fullName}</NavLink>
                            ) : (
                                <p style={{color: '#002e33'}}>{user.fullName}</p>
                            )}
                        </p>
                        {user.cuts !== null || user.efficiency !== null ? (
                        <div className="data-statistic">
                            {user.cuts !== null && (
                            <div className="data-statisitc-item">
                                <span className="data-statistic-text">Срезы {" "}</span>
                                <span
                                    className={`data-statistic-val completed-count ${user.cuts > 50 ? '' : 'low'}`}>
                                            {user.cuts}%
                                </span>
                            </div>
                            )}
                            {user.efficiency !== null && (
                            <div className="data-statisitc-item">
                                <span className="data-statistic-text">Эффективность {" "}</span>
                                <span
                                    className={`data-statistic-val completed-count ${user.efficiency > 50 ? '' : 'low'}`}>
                                    {user.efficiency}%
                                </span>
                            </div>
                            )}
                        </div>
                        ) : null}
                    </div>
                </div>
            </div>
            <div className="col status-col full-width-mobile">
                <span className="col-title">Статус</span>
                <span className="status">
                    {user.status === 'done' ? (
                        <>
                            <span>Тест пройден</span>
                            <span><CorrectIcon/></span>
                        </>
                    ) : user.status === 'notDone' ? (
                        <span>Не пройден</span>
                    ) : (
                        <span>Ожидает выполнения</span>
                    )}
                </span>

            </div>

            <div className="col lesson-time-col full-width-mobile">
                <span className="col-title">Группа</span>
                <p>
                    <NavLink to={`/groups/${user.group?.id}`}>{user.group?.title}</NavLink>
                </p>
            </div>

            <div className="col current-level-col">
                <span className="col-title">Ответы</span>
                {user.answersAll !== null && user.questionsAll !== null && (
                    <p>{user.answersAll}/{user.questionsAll}</p>
                )}
            </div>
            <div className="col classes-attended-col align-right">
                <span className="col-title">Правильные ответы</span>
                {user.answersRight !== null && user.questionsAll !== null && (
                    <p>{user.answersRight}/{user.questionsAll}</p>
                )}
            </div>


            {user.status === 'done' && (
                <div className="col btn-link-col">
                    <NavLink
                        style={{borderBottom: 'none', textShadow: 'none'}}
                        className="circle-arrow-btn"
                        to={`/test/${testId}/view-answer/${user.id}`}
                    >
                        <ArrayIcon/>
                    </NavLink>
                </div>
            )}

        </div>
    );
};

